"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReactReduxFirebaseContext", {
  enumerable: true,
  get: function () {
    return _ReactReduxFirebaseContext.default;
  }
});
Object.defineProperty(exports, "ReactReduxFirebaseProvider", {
  enumerable: true,
  get: function () {
    return _ReactReduxFirebaseProvider.default;
  }
});
Object.defineProperty(exports, "ReduxFirestoreContext", {
  enumerable: true,
  get: function () {
    return _ReduxFirestoreContext.default;
  }
});
Object.defineProperty(exports, "ReduxFirestoreProvider", {
  enumerable: true,
  get: function () {
    return _ReduxFirestoreProvider.default;
  }
});
Object.defineProperty(exports, "actionTypes", {
  enumerable: true,
  get: function () {
    return _constants.actionTypes;
  }
});
Object.defineProperty(exports, "authIsReady", {
  enumerable: true,
  get: function () {
    return _auth.authIsReady;
  }
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function () {
    return _constants.default;
  }
});
Object.defineProperty(exports, "createFirebaseInstance", {
  enumerable: true,
  get: function () {
    return _createFirebaseInstance.default;
  }
});
Object.defineProperty(exports, "firebaseConnect", {
  enumerable: true,
  get: function () {
    return _firebaseConnect.default;
  }
});
exports.firebaseReducer = void 0;
Object.defineProperty(exports, "firestoreConnect", {
  enumerable: true,
  get: function () {
    return _firestoreConnect.default;
  }
});
Object.defineProperty(exports, "getFirebase", {
  enumerable: true,
  get: function () {
    return _createFirebaseInstance.getFirebase;
  }
});
Object.defineProperty(exports, "getVal", {
  enumerable: true,
  get: function () {
    return _helpers.getVal;
  }
});
Object.defineProperty(exports, "isEmpty", {
  enumerable: true,
  get: function () {
    return _helpers.isEmpty;
  }
});
Object.defineProperty(exports, "isLoaded", {
  enumerable: true,
  get: function () {
    return _helpers.isLoaded;
  }
});
Object.defineProperty(exports, "populate", {
  enumerable: true,
  get: function () {
    return _helpers.populate;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function () {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "useFirebase", {
  enumerable: true,
  get: function () {
    return _useFirebase.default;
  }
});
Object.defineProperty(exports, "useFirebaseConnect", {
  enumerable: true,
  get: function () {
    return _useFirebaseConnect.default;
  }
});
Object.defineProperty(exports, "useFirestore", {
  enumerable: true,
  get: function () {
    return _useFirestore.default;
  }
});
Object.defineProperty(exports, "useFirestoreConnect", {
  enumerable: true,
  get: function () {
    return _useFirestoreConnect.default;
  }
});
Object.defineProperty(exports, "withFirebase", {
  enumerable: true,
  get: function () {
    return _withFirebase.default;
  }
});
Object.defineProperty(exports, "withFirestore", {
  enumerable: true,
  get: function () {
    return _withFirestore.default;
  }
});

var _createFirebaseInstance = _interopRequireWildcard(require("./createFirebaseInstance"));

var _ReactReduxFirebaseProvider = _interopRequireDefault(require("./ReactReduxFirebaseProvider"));

var _ReactReduxFirebaseContext = _interopRequireDefault(require("./ReactReduxFirebaseContext"));

var _ReduxFirestoreProvider = _interopRequireDefault(require("./ReduxFirestoreProvider"));

var _ReduxFirestoreContext = _interopRequireDefault(require("./ReduxFirestoreContext"));

var _firebaseConnect = _interopRequireDefault(require("./firebaseConnect"));

var _firestoreConnect = _interopRequireDefault(require("./firestoreConnect"));

var _withFirebase = _interopRequireDefault(require("./withFirebase"));

var _withFirestore = _interopRequireDefault(require("./withFirestore"));

var _useFirebaseConnect = _interopRequireDefault(require("./useFirebaseConnect"));

var _useFirestoreConnect = _interopRequireDefault(require("./useFirestoreConnect"));

var _useFirebase = _interopRequireDefault(require("./useFirebase"));

var _useFirestore = _interopRequireDefault(require("./useFirestore"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _constants = _interopRequireWildcard(require("./constants"));

var _auth = require("./utils/auth");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const firebaseReducer = _reducer.default;
exports.firebaseReducer = firebaseReducer;